var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "46px",
    viewBox: "0 0 48 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.000000, -35.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6909091,
    cy: 10.6972549,
    rx: 10.6909091,
    ry: 10.6070588
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3090909,
    cy: 10.6972549,
    rx: 10.6909091,
    ry: 10.6070588
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6909091,
    cy: 35.3027451,
    rx: 10.6909091,
    ry: 10.6070588
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3090909,
    cy: 35.3027451,
    rx: 10.6909091,
    ry: 10.6070588
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrey);
export default __webpack_public_path__ + "static/media/trey.cfc46e2bac4dd2ead69d4d1a8a552777.svg";
export { ForwardRef as ReactComponent };